import React from "react";
import { connect } from "react-redux";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  SelectControl,

} from "../../utils/form";
import { Row, Col, Button } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import "react-datepicker/dist/react-datepicker.css";
import { getAllTemplatesApi, getAllContentTypeApi, getDetailsTemplateApi, getTemplateVariationDimensionsApi } from "./Api";
import { ImageUploader, Spinner, TemplatesContent } from "../common";
import ReactDOM from "react-dom";
import { postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import { toast } from "react-toastify";
import { isModuleExist, MAX_LIMIT, MODULE_ID_MAP, YesNoOptions } from "../../utils/Constant";
import { getAllSsoPartnersApi } from "../sso/Api";
import { isPartnerAllowed } from "../../utils/ReusableFunctions";
import { MINIMALIST } from "../common/canvasV1/shared-canvas";
import { withRouter } from "../../utils/hoc/withRouter";



class AddEditContentTemplates extends BaseReactComponent {
  constructor(props) {
    super(props);
    const type = new URLSearchParams(this.props.location.search).get("type") || "content";
    const data = props?.location.state?.data || null;
    let module = MODULE_ID_MAP.ContentMasterTemplate
    if (type === "personalization") {
      module = MODULE_ID_MAP.PersonalizationCustomTemplate
    }
    const AccesData = isModuleExist(module);
    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }

    this.state = {
      AccessData: AccesData,
      editData: data,
      templateUuid: data?.uuid || "",
      isUpdated: (props?.location.state ?? false) || false,
      thumbnailFile: null,
      isAddContent: true,
      uploadImage: data?.calenderImage || null,
      resLoading: false,
      templateName: "",
      description: data?.description || "",
      dimensionUuid: "",
      contentTypeUuid: "",
      isCanvasOpen: false,
      pageNumber: "",
      canvasHeight: "",
      canvasWidth: "",
      backgroundColor: "",
      pageSize: MAX_LIMIT,
      personalizationTemplateVariationImages: [],
      personalizationTemplateVariationImage: [],
      variationData: {},
      variations: [],
      dimensionOptions: [],
      currentVariationIndex: "",
      filter: [],
      isPremium: false,
      ssoPartnersOptions: [],
      partners,
      contentTypeDimensionsOptions: [],
      type
    };

  };


  async componentDidMount() {
    getTemplateVariationDimensionsApi(this);
    getAllSsoPartnersApi(this);

    if (this.props?.location?.state?.data?.uuid) {
      this.setState({ loading: true })
      const detailsPath = this.state.type === "personalization"
        ? "/personalizationCustomTemplate"
        : "/contentTemplate";
      await getDetailsTemplateApi(detailsPath, this).finally(() => {
        this.setState({ loading: false })
      });
      this.syncVariationsWithDimensions();
    };


  };

  imageUploaser = (e, name) => {

    const imageUrl = URL.createObjectURL(e.target.files[0]);
    this.setState({ iconImagePath: e.target.files[0].name, thumbnailFile: e.target.files[0], uploadImage: imageUrl })

  };
  setDimensions = () => {
    const { dimensionUuid, contentTypeUuid, contentTypeDimensionsOptions } = this.state;


    const selectedContentType = contentTypeDimensionsOptions?.find(option => option.value === contentTypeUuid);
    const selectedOption = selectedContentType?.dimensions?.find(option => option.value === dimensionUuid);

    if (selectedOption) {

      const [widthStr, heightStr] = selectedOption.dimensions?.split('×');
      let canvasWidth = Number(widthStr);
      let canvasHeight = Number(heightStr);


      if (selectedContentType?.contentCode === MINIMALIST) {
        canvasHeight = 200;
        canvasWidth = 1080;
      }


      this.setState({ canvasWidth, canvasHeight, contentType: selectedContentType?.contentCode });


    }
  };

  getVariationDimensionUuid = (variation) => {
    return variation?.personalizationDimensionUuid || variation?.personalizationDimension?.uuid || variation?.dimensionUuid || "";
  };

  cloneVariationImages = (images = []) => {
    return JSON.parse(JSON.stringify(images || []));
  };

  /** Content master: all dimensions. Personalization: Landscape only. */
  getEffectiveDimensionOptions = (dimensionOptions = this.state.dimensionOptions) => {
    if (!dimensionOptions?.length) return [];
    if (this.state.type !== "personalization") return dimensionOptions;

    const landscape = dimensionOptions.find(
      (d) => (d.label || "").toLowerCase() === "landscape"
    );
    return landscape ? [landscape] : dimensionOptions.slice(0, 1);
  };

  syncVariationsWithDimensions = (dimensionOptions = this.state.dimensionOptions) => {
    const effectiveOptions = this.getEffectiveDimensionOptions(dimensionOptions);
    if (!effectiveOptions?.length) {
      return;
    }

    const currentVariations = this.state.variations || [];
    const variations = effectiveOptions.map((dimension) => {
      // Prefer dimension match; personalization custom templates have no language /
      // often null variation.dimension — fall back to the first saved variation.
      let existingVariation = currentVariations.find(
        (variation) => this.getVariationDimensionUuid(variation) === dimension.value
      );
      if (!existingVariation && this.state.type === "personalization") {
        existingVariation = currentVariations[0];
      }
      existingVariation = existingVariation || {};

      return {
        ...existingVariation,
        personalizationDimensionUuid: dimension.value,
        personalizationDimensionName: dimension.label,
        dimension: dimension.dimensions,
        personalizationTemplateVariationImages: existingVariation.personalizationTemplateVariationImages?.length
          ? this.cloneVariationImages(existingVariation.personalizationTemplateVariationImages)
          : [this.getBlankVariationImage({
            personalizationDimensionUuid: dimension.value,
            dimension: dimension.dimensions
          })]
      };
    });

    if (JSON.stringify(currentVariations) !== JSON.stringify(variations)) {
      this.setState({ variations });
    }
  };

  getCanvasDimension = (variation) => {
    // Personalization custom templates always use MINIMALIST strip size.
    if (this.state.type === "personalization") {
      return { canvasWidth: 1080, canvasHeight: 200 };
    }

    const [widthStr, heightStr] = (variation?.dimension || "").split(/[\u00d7xX]/);
    const canvasWidth = Number(widthStr);
    const canvasHeight = Number(heightStr);

    return {
      canvasWidth: canvasWidth || 500,
      canvasHeight: canvasHeight || 300,
    };
  };

  getBlankVariationImage = (variation) => {
    const { canvasWidth, canvasHeight } = this.getCanvasDimension(variation);

    return {
      pageNumber: 1,
      canvasWidth,
      canvasHeight,
      backgroundColor: "#ffffff",
      personalizationDimensionUuid: this.getVariationDimensionUuid(variation),
      layers: []
    };
  };

  openCanvas = (index) => {
    const variation = this.state.variations[index];
    if (!variation?.personalizationDimensionUuid) {
      toast.error("Variation dimension is required")
    } else {
      const { canvasWidth, canvasHeight } = this.getCanvasDimension(variation);
      this.setState({
        isCanvasOpen: true,
        currentVariationIndex: index,
        personalizationTemplateVariationImages: variation.personalizationTemplateVariationImages?.length
          ? this.cloneVariationImages(variation.personalizationTemplateVariationImages)
          : [this.getBlankVariationImage(variation)],
        canvasWidth,
        canvasHeight,
        contentType: MINIMALIST
      })
    }
  };

  updateCanvasData = (updatedCanvasData) => {
    const { currentVariationIndex, variations } = this.state;
    const updatedVariations = [...variations];
    updatedVariations[currentVariationIndex] = {
      ...updatedVariations[currentVariationIndex],
      personalizationTemplateVariationImages: this.cloneVariationImages(updatedCanvasData)
    };

    this.setState({
      variations: updatedVariations,
      isCanvasOpen: false,
      pageNumber: updatedCanvasData[0]?.pageNumber,
      variationData: updatedCanvasData[0],
      personalizationTemplateVariationImage: updatedCanvasData[0]?.layers
    });
  };



  processedVariations = (variations) => {
    return variations.map((variation, index) => ({
      languageUuid: variation?.languageUuid,
      personalizationTemplateVariationImages: [
        {
          pageNumber: this.state.pageNumber || index + 1,
          canvasHeight: this.state.canvasHeight,
          canvasWidth: this.state.canvasWidth,
          layers: variation?.personalizationTemplateVariationImage || [], // Set
        },
      ],
    }));
  };



  handlePageSize = (pageSize) => {

  };
  handleSave = () => {
    ReactDOM.findDOMNode(this.form).dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  onValidSubmit = async () => {
    this.setState({ resLoading: true });
    const { templateName, description, variations, thumbnailFile, uploadImage, isPremium, isDefault } = this.state;
    const personalizationTemplateVariations = (variations || []).map((variation, index) => ({
      ...(variation?.uuid ? { uuid: variation.uuid } : {}),
      personalizationDimensionUuid: this.getVariationDimensionUuid(variation),
      personalizationTemplateVariationImages: this.cloneVariationImages(variation.personalizationTemplateVariationImages)
    }));

    if (!thumbnailFile && !uploadImage) {
      toast.error("Please fill all required fields");
      this.setState({ resLoading: false });
      return;
    }
    else if (!personalizationTemplateVariations.length) {
      toast.error("Atleast one variation is required");
      this.setState({ resLoading: false });
      return;
    }
    else if (personalizationTemplateVariations.some((variation) => !variation.personalizationDimensionUuid)) {
      toast.error("Variation dimension is required");
      this.setState({ resLoading: false });
      return;
    }


    else {
      const templateData = {
        "data": {
          "templateName": templateName,
          "thumbnailImage": thumbnailFile?.name,
          "description": description,
          "isPremium": isPremium === "true",
          'partners': this.state.partners,
          "personalizationTemplateVariations": personalizationTemplateVariations
        }
      }

      // Personalization custom templates store dimension on the template (top-level),
      // matching API shape where variation.personalizationDimension is often null.
      if (this.state.type === "personalization") {
        templateData.data.personalizationDimensionUuid =
          personalizationTemplateVariations[0]?.personalizationDimensionUuid || "";
      }

      if (!isPartnerAllowed(this.state.AccessData?.id)) {
        delete templateData.data.partners;
      }


      const data = new FormData();
      data.append("key", JSON.stringify(templateData));
      if (this.state.thumbnailFile) {
        data.append("file", this.state?.thumbnailFile);
      };

      let url = "contentTemplate"
      let backUrl = "/template"
      if (this.state.type === "personalization") {
        url = "personalizationCustomTemplate"
        backUrl = "/personalization-custom-template"
      }

      if (this.state.templateUuid) {
        const response = await putAuthCommonApi(`/${url}/${this.state.templateUuid}`, data);
        if (response.status === 200) {
          this.setState({ resLoading: false });
          this.props.history({ pathname: backUrl, search: 'pageSize=10&pageNumber=1' });
        } else {
          this.setState({ resLoading: false });
        }
      } else {
        const response = await postAuthCommonApi(`/${url}`, data);
        if (response.status === 200) {
          this.setState({ resLoading: false });
          this.props.history({ pathname: backUrl, search: 'pageSize=10&pageNumber=1' });
        } else {
          this.setState({ resLoading: false });
        }
      }
    }

  };


  render() {
    const {
      uploadImage,
      thumbnailFile,
      isCanvasOpen,
      loading

    } = this.state;



    return (
      <>

        {isCanvasOpen ?
          <div className="canvas-section">

            <TemplatesContent
              key={this.state.variations?.[this.state.currentVariationIndex]?.personalizationDimensionUuid || this.state.currentVariationIndex}
              onClose={() => this.setState({ isCanvasOpen: false })}
              onSave={(updatedCanvasData) => this.updateCanvasData(updatedCanvasData)}
              personalizationTemplateVariationImages={this?.state?.personalizationTemplateVariationImages}
              canvasKey={this.state.variations?.[this.state.currentVariationIndex]?.personalizationDimensionUuid}
              contentType={this.state.contentType}
              width={this.state.canvasWidth}
              height={this.state.canvasHeight}
            />

          </div>
          :
          <section className="add-section">
            <ComponentHeader
              title={this.state.templateUuid ? "Update Template" : "Add Template"}
              primaryBtn="Save"
              isBackArrow={true}
              resLoading={this.state.resLoading}
              isReturn="/template?pageSize=10&pageNumber=1"
              handlePrimaryBtn={this.handleSave}
              breadcrumb={[[this.state.type === "content" ? "Content Master" : "Personlization", ""], ["Custom Templates", this.state.type === "content" ? "/template" : "/personalization-custom-template"], [this.state.templateUuid ? "Edit Template" : "Add Template", ""]]}
            />
            {loading ?
              <div className="inter-medium f-s-18 lh-22 text-center py-5 d-flex align-items-center justify-content-center gap-12"> <Spinner classes={'black-border'} /> Loading...</div>

              :

              <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>
                <Row>
                  {isPartnerAllowed(this.state.AccessData?.id) &&
                    <Col md={4}>
                      <FormElement
                        valueLink={this.linkState(this, "partners.list")}
                        label="Publish To Partner(s)"
                        required
                        validations={[
                          {
                            validate: FormValidator.isRequired,
                            message: "Publish To cannot be empty",
                          },
                        ]}
                        control={{
                          type: SelectControl,
                          settings: {
                            options: this.state?.ssoPartnersOptions || [],
                            placeholder: "Select Partner(s)",
                            multiple: true,
                            searchable: true,
                            selectAll: true,
                            onChangeCallback: (onBlur) => {
                            },
                          },
                        }}
                      />

                    </Col>}
                  <Col md={4}>
                    <FormElement
                      valueLink={this.linkState(this, "templateName")}
                      label="Template Name"
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Name cannot be empty",
                        },
                      ]}
                      control={{
                        type: CustomTextControl,
                        settings: {
                          placeholder: "Enter Name",
                        },
                      }}
                    />
                  </Col>
                </Row>
                <Row>

                  {/* <Col md={4}>
                    <FormElement
                      valueLink={this.linkState(this, "filter")}
                      label="Select Format"
                      validations={[]}
                      control={{
                        type: SelectControl,
                        settings: {
                          placeholder: "Select Format",
                          options: filterOptions,
                          multiple: true,
                          searchable: true,
                        },
                      }}
                    />
                    {this.state.filter?.length > 0 &&
                      <ClearButton onClick={() => this.setState({ filter: [] })} />
                    }
                  </Col> */}

                  <Col md={4}>
                    <FormElement
                      valueLink={this.linkState(this, "isPremium")}
                      label="Is Premium"
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Premium Field cannot be empty",
                        },
                      ]}
                      control={{
                        type: SelectControl,
                        settings: {
                          options: YesNoOptions,
                          multiple: false,
                          searchable: true,
                          onChangeCallback: (onBlur) => {
                            onBlur(this.state.isPremium);
                          },
                        },
                      }}
                    />
                  </Col>

                  <Col sm={4}>
                    <ImageUploader required={true} id="Thumbnail" label="Upload Thumbnail" name={typeof (thumbnailFile) == 'object' ? uploadImage : thumbnailFile} onChange={(e) => this.imageUploaser(e, "thumbnail")} onDelete={() => this.setState({ thumbnailFile: null, uploadImage: null })} />
                  </Col>
                </Row>
                <Row>

                  <Col md={6}>
                    <FormElement
                      valueLink={this.linkState(this, "description")}
                      label="Description"
                      helpText="Description can't be more than 4000 character"

                      control={{
                        type: CustomTextControl,
                        settings: {
                          placeholder: "Please enter description",
                          as: "textarea",
                          rows: 5,
                        },
                      }}
                      classes={{
                        inputField: "custom-input",
                        label: "custom-label",
                      }}
                    />
                  </Col>

                  {/* <Col sm={2} className="mt-5 ">

                   <input type="checkbox" className="mr-3" name="isDefault" id="isDefault" checked={this.state.isDefault} onChange={(e) => this.setState({ isDefault: !this.state.isDefault })} />
                   <label htmlFor="isDefault">Is Default</label>
                  </Col> */}
                  {this.state.type === "personalization" ? (
                    <Col sm={4}>
                      <Button onClick={() => this.openCanvas(0)} className="primary-btn ml-4 mt-5">
                        Open Canvas
                      </Button>
                    </Col>
                  ) : (
                    <>
                      <Col md={12}>
                        <p className="inter-semibold f-s-19 lh-24 section-title">Variations</p>
                      </Col>
                      <Col sm={12}>
                        <Row>
                          {this.state.variations?.map((variation, index) => (
                            <Col sm={12} key={variation.personalizationDimensionUuid || index}>
                              <Row className="variation-wrapper mt-4 d-flex align-items-center gap-10">
                                <Col md={4}>
                                  <div>
                                    <p className="variation-srno">Variation - {index + 1}</p>
                                    <h3 className="inter-semibold f-s-14 mb-2">{variation.personalizationDimensionName || "Dimension"}</h3>
                                    {variation.dimension &&
                                      <p className="inter-regular f-s-12 grey-2 mb-3">{variation.dimension}</p>
                                    }
                                  </div>
                                </Col>

                                <Col md={6}>
                                  <Button onClick={() => this.openCanvas(index)} className="primary-btn">
                                    Open Canvas
                                  </Button>
                                </Col>
                              </Row>
                              <hr />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </>
                  )}

                </Row>

              </Form>
            }
          </section>
        }


      </>
    );
  }
}

const mapStateToProps = (state) => ({
  calenderFilterData: state.SubdomainState.calenderFilterList,
});
const mapDispatchToProps = {
  getAllTemplatesApi,
  getAllContentTypeApi

};
AddEditContentTemplates.propTypes = {


};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddEditContentTemplates));
